module.exports = __webpack_public_path__ + "static/media/icon_share.7a752bc7.svg";